/**
 * 安全的 localStorage 封装，在 iframe、隐私模式等无法访问 storage 的上下文中捕获异常，避免报错
 */
function getItem(key) {
	try {
		if (typeof window === 'undefined' || !window.localStorage) return null
		return window.localStorage.getItem(key)
	} catch (e) {
		return null
	}
}

function setItem(key, val) {
	try {
		if (typeof window === 'undefined' || !window.localStorage) return
		window.localStorage.setItem(key, val)
	} catch (e) {
		// 忽略
	}
}

export const storage = { getItem, setItem }
